// Student "pin to top" preference — a plain array of composite keys
// (`${kind}:${id}`) on the student's own users/{uid}/profile/main doc.
// Purely a display preference (which of MY OWN Home cards sort first), so
// a direct client Firestore write is fine — firestore.rules already lets
// an owner write any field on their own profile/main except the school-
// link fields (see that rule's own comment), and pinnedItems isn't one of
// those.
import { doc, setDoc, arrayUnion, arrayRemove, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase.js';

export function pinKey(kind, id) {
  return `${kind}:${id}`;
}

export async function setPinned(uid, key, pinned) {
  const ref = doc(db, 'users', uid, 'profile', 'main');
  await setDoc(ref, { pinnedItems: pinned ? arrayUnion(key) : arrayRemove(key) }, { merge: true });
}

// watchPinnedItems — live Set of this student's pinned keys, so every Home
// section re-sorts immediately when a pin is toggled (including from
// another open tab).
export function watchPinnedItems(uid, callback) {
  const ref = doc(db, 'users', uid, 'profile', 'main');
  return onSnapshot(ref, (snap) => {
    const items = snap.exists() && Array.isArray(snap.data().pinnedItems) ? snap.data().pinnedItems : [];
    callback(new Set(items));
  });
}
